var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "more",
    d: "M-7235.5,1523a12.416,12.416,0,0,1-8.838-3.662A12.418,12.418,0,0,1-7248,1510.5a12.416,12.416,0,0,1,3.662-8.838A12.417,12.417,0,0,1-7235.5,1498a12.418,12.418,0,0,1,8.838,3.661A12.416,12.416,0,0,1-7223,1510.5a12.418,12.418,0,0,1-3.662,8.839A12.417,12.417,0,0,1-7235.5,1523Zm6.268-13.952a1.717,1.717,0,0,0-1.715,1.715,1.718,1.718,0,0,0,1.715,1.716,1.717,1.717,0,0,0,1.714-1.716A1.717,1.717,0,0,0-7229.232,1509.049Zm-5.9,0a1.717,1.717,0,0,0-1.715,1.715,1.718,1.718,0,0,0,1.715,1.716,1.718,1.718,0,0,0,1.716-1.716A1.717,1.717,0,0,0-7235.133,1509.049Zm-5.9,0a1.717,1.717,0,0,0-1.716,1.715,1.718,1.718,0,0,0,1.716,1.716,1.718,1.718,0,0,0,1.715-1.716A1.717,1.717,0,0,0-7241.033,1509.049Z",
    transform: "translate(7248 -1498.001)",
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/more-icon.3ffe882f.svg";
export { ForwardRef as ReactComponent };